import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import {
  createCashRegister,
  deleteCashRegister,
  getCashRegister,
  getCashRegisters,
  updateCashRegister,
} from './actionCreators';
import { FINANCIAL_SETTINGS_SLICE_NAME, FinancialSettingsState, initialState } from './models';

export const slice = createSlice({
  name: FINANCIAL_SETTINGS_SLICE_NAME,
  initialState,
  reducers: {
    resetFinancialSettingsState() {
      return { ...initialState };
    },
    resetCashRegister(state: FinancialSettingsState) {
      state.cashRegister = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCashRegisters.fulfilled, (state: FinancialSettingsState, action) => {
        state.cashRegisters = action.payload;
        state.isLoading = false;
      })
      .addCase(deleteCashRegister.fulfilled, (state: FinancialSettingsState) => {
        state.isLoading = false;
      })
      .addCase(updateCashRegister.fulfilled, (state: FinancialSettingsState) => {
        state.isLoading = false;
      })
      .addMatcher(isFulfilled(createCashRegister, getCashRegister), (state: FinancialSettingsState, action) => {
        state.cashRegister = action.payload.data;
        state.isLoading = false;
      })
      .addMatcher(
        isPending(getCashRegisters, getCashRegister, createCashRegister, updateCashRegister, deleteCashRegister),
        (state: FinancialSettingsState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(getCashRegisters, getCashRegister, createCashRegister, updateCashRegister, deleteCashRegister),
        (state: FinancialSettingsState, action) => {
          const { error } = action;
          state.error = error;
          state.isLoading = false;

          showApiErrors(error);
        },
      );
  },
});

export const { resetFinancialSettingsState, resetCashRegister } = slice.actions;

export default slice.reducer;
